import { useEffect } from "react";

const Terms = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="flex min-h-[calc(100vh-73px)] items-center justify-center px-4 py-8">
      <div className="max-w-5xl space-y-6 overflow-y-auto rounded-md border bg-white p-8 text-left text-gray-800">
        <h1 className="mb-4 text-3xl font-bold">Terms of Service</h1>

        <p>
          These terms and conditions ("Terms", "Agreement") are an agreement between Website Operator
          ("Website Operator", "us", "we" or "our") and you ("User", "you" or "your"). This Agreement sets
          forth the general terms and conditions of your use of the hellocode.me website and any of its
          products or services (collectively, "Website" or "Services").
        </p>

        <h2 className="mt-6 text-2xl font-semibold">Accounts and Membership</h2>
        <p>
          If you create an account on the Website, you are responsible for maintaining the security of your
          account, and you are fully responsible for all activities that occur under the account, and any
          other actions taken in connection with it. Providing false contact information of any kind may
          result in the termination of your account. You must immediately notify us of any unauthorized uses
          of your account, or any other breaches of security. We will not be liable for any acts or omissions
          by you, including any damages of any kind incurred as a result of such acts or omissions. Hello Code
          will NOT deal with, or provide any services or products to any of OFAC sanctions countries, and that
          is in accordance with the laws of Hashemite Kingdom of Jordan.
        </p>

        <h2 className="mt-6 text-2xl font-semibold">Subscription Modules</h2>
        <p>
          HelloCode® provides its service to both kids as individuals and/or as school students, where they
          can access the entire courses and the educational content, as well as the tools; SmoothY®,
          programming language IDE, and the playground, all on periodic subscription basis.
        </p>
        <p>
          Currently, Hello World Kids offers three types of periodic subscriptions – noting that each of the
          modules is per child/student:
        </p>
        <ul className="list-inside list-disc space-y-1">
          <li>
            <strong>THREE-Month Subscription:</strong> unlimited access to all content and tools.
          </li>
          <li>
            <strong>SIX-Month Subscription:</strong> unlimited access to all content and tools.
          </li>
          <li>
            <strong>TWELVE-Month Subscription:</strong> unlimited access to all content and tools.
          </li>
        </ul>
        <p>
          HelloCode® grants a free trial period of THREE days for the first THREE lessons. After that,
          charges will apply. Subscriptions renew automatically unless canceled by the parent from the portal.
        </p>

        <h2 className="mt-6 text-2xl font-semibold">Fees and Payment and Refunds</h2>
        <p>
          You can cancel your subscription at any time. However, refunds are only given for same-day
          cancellations or billing errors. Otherwise, content remains available regardless of cancellation.
          Contact: info@helloworldkids.org.
        </p>

        <h2 className="mt-6 text-2xl font-semibold">Age Restriction</h2>
        <p>
          Users under 18 cannot register or transact. Children’s data is collected from parents/schools and
          used solely for verification. No advertising or direct contact will occur with children.
        </p>

        <h2 className="mt-6 text-2xl font-semibold">Backups</h2>
        <p>
          We are not responsible for user content backups. Restoration may be possible in some cases but is
          not guaranteed.
        </p>

        <h2 className="mt-6 text-2xl font-semibold">Prohibited Uses</h2>
        <p>
          You agree not to use the Website for unlawful or harmful purposes including hacking, harassing,
          spamming, or violating intellectual property rights. Violation may result in termination.
        </p>

        <h2 className="mt-6 text-2xl font-semibold">Intellectual Property Rights</h2>
        <p>
          All content, trademarks, and intellectual property remain the property of Website Operator or their
          licensors. Use of the website does not grant ownership or license.
        </p>

        <h2 className="mt-6 text-2xl font-semibold">Limitation of Liability</h2>
        <p>
          Website Operator is not liable for indirect or incidental damages. Our total liability is limited to
          one dollar or the amount you paid in the prior month.
        </p>

        <h2 className="mt-6 text-2xl font-semibold">Indemnification</h2>
        <p>
          You agree to indemnify us from claims or disputes arising from your use of the Website, services, or
          content.
        </p>

        <h2 className="mt-6 text-2xl font-semibold">Term and Termination</h2>
        <p>
          You may stop using the service at any time. We reserve the right to modify, suspend, or terminate
          the service or your access without notice.
        </p>

        <h2 className="mt-6 text-2xl font-semibold">Severability</h2>
        <p>If any provision is found invalid, the remaining provisions will still apply.</p>

        <h2 className="mt-6 text-2xl font-semibold">Dispute Resolution</h2>
        <p>
          This agreement is governed by the laws of the Hashemite Kingdom of Jordan. Disputes must be handled
          by Jordanian courts.
        </p>

        <h2 className="mt-6 text-2xl font-semibold">Changes and Amendments</h2>
        <p>
          We may update these terms at any time. Your continued use of the website means you accept the
          changes. We will notify you by email.
        </p>

        <h2 className="mt-6 text-2xl font-semibold">Acceptance of These Terms</h2>
        <p>
          By using this Website, you agree to abide by these terms. If you do not agree, you should not use
          the site.
        </p>

        <h2 className="mt-6 text-2xl font-semibold">Contacting Us</h2>
        <p>
          If you have questions, contact us at:{" "}
          <a href="mailto:info@helloworldkids.org" className="text-blue-600 underline">
            info@helloworldkids.org
          </a>
        </p>

        <p className="text-sm text-gray-600">Last updated: December 20, 2018</p>
      </div>
    </div>
  );
};

export default Terms;
